import { Minus, Plus } from "lucide-react";

export default function BookExperiences({ experiences, selected, setExperienceQty, formatMoney, t }) {
    return (
        <div className="mb-10">
            <div className="eyebrow mb-4">{t("book.step3")}</div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-testid="book-experiences">
                {experiences.map((e) => {
                    const qty = selected[e.id] || 0;
                    return (
                        <div key={e.id} className={`border ${qty > 0 ? "border-forest bg-forest/5" : "border-espresso/15"} p-5 flex gap-4`} data-testid={`book-exp-${e.id}`}>
                            <div className="w-20 h-20 bg-bone2 flex-shrink-0 overflow-hidden">
                                <img src={e.image} alt={e.name} className="w-full h-full object-cover" />
                            </div>
                            <div className="flex-1">
                                <div className="text-[10px] uppercase tracking-widest2 text-espresso/70 mb-1">{e.category} · {e.duration} · {formatMoney(e.price)}</div>
                                <div className="font-serif text-xl leading-tight mb-2">{e.name}</div>
                                <p className="text-xs text-muted2 line-clamp-2 mb-3">{e.description}</p>
                                <div className="flex items-center gap-2">
                                    <button onClick={() => setExperienceQty(e.id, qty - 1)} disabled={qty <= 0} data-testid={`exp-decr-${e.id}`} className="w-7 h-7 border border-espresso/30 inline-flex items-center justify-center disabled:opacity-30" aria-label="Decrease">
                                        <Minus size={12} />
                                    </button>
                                    <span className="w-8 text-center text-sm" data-testid={`exp-qty-${e.id}`}>{qty}</span>
                                    <button onClick={() => setExperienceQty(e.id, qty + 1)} data-testid={`exp-incr-${e.id}`} className="w-7 h-7 border border-espresso/30 inline-flex items-center justify-center hover:bg-bone2" aria-label="Increase">
                                        <Plus size={12} />
                                    </button>
                                </div>
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
}
